import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import ImageUploading, { ImageListType, ImageType } from 'react-images-uploading';

import { gql, useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Link, useHistory } from 'react-router-dom';
import { Article } from '../../../../types';
import { TinyProps, useTiny } from '../../../../utils/hooks/useTiny';
import { Admincontent, AdminContext } from '../../../containers/Admin';
import { Button } from '../../../ui/button/Button';
import { Input } from '../../../ui/form/Input';
import { getAdminClient, getUploadClient } from '../AdminApolloClient';
import { InputRow } from '../../../ui/form/InputRow';
import { DropdownMenu, options } from '../../../ui/dropdown/DropdownMenu';
import { ButtonGroup } from '../../../ui/button/ButtonGroup';
import { checkOfficeTag, IsReeltimeTag } from '../../../../utils/helpers/checkOfficeTag';

//GraphQL
import { UPDATE_NEWS_MUTATION } from '../../../../../client/__graphql__/mutations/updateNews';
import { UPDATE_NEWS_IMAGE_MUTATION } from '../../../../../client/__graphql__/mutations/updateNewsImage';
import { SINGLE_NEWS_QUERY } from '../../../../../client/__graphql__/queries/getSingleNews';

//Category
import { NEWS_CATEGORY } from '../../../../../client/__graphql__/queries/getNewsCategory';
import { Toggle } from 'react-toggle-component';
import { NewsType } from '../../../../../client/types/generated/types';
import { isExternalURL } from '../../../../utils/helpers/url';

const client = getUploadClient();

interface Category {
  id: number | null;
  name: string | null;
  category_id: number;
  edit_ingress: boolean;
}

const Form = React.memo(
  (props: { tiny: TinyProps; articleData: Article; category: any; urltag: string; ingressVisible?: boolean }) => {
    const [images, setImages] = React.useState([]);
    const [maxImages, SetMaxNumber] = React.useState(1);
    const [catData, setCatData] = useState(props.category);
    const [articleData, setArticleData] = useState<Article>(props.articleData);
    const [showIngress, setShowIngress] = useState(props.ingressVisible); // Laster props objektet
    const [publish, SetPublish] = useState<boolean>(props?.articleData?.published ? props?.articleData?.published.length > 0 : false);
    const history = useHistory();
    const context = useContext(AdminContext);
    const [showUpload, setShowUpload] = useState(!(articleData && articleData?.id && articleData?.id > 0 && articleData?.image));

    const [submitNews, { error: submitError, loading: submitLoading, data: submitData }] = useMutation(UPDATE_NEWS_IMAGE_MUTATION, {
      client,
      onCompleted: (data: any) => {
        if (data?.updateNewsImage && data?.updateNewsImage?.id > 0) {
          if (articleData.id && articleData.id > 0) {
            alert('Artikkelen har blitt oppdatert!');
          } else {
            alert('Artikkelen har blitt lagret!');
            setArticleData({
              ...articleData,
              ['id']: data?.updateNewsImage?.id
            });
          }
        } else {
          alert('Noe gikk galt!');
        }
      }
    });

    useEffect(() => {
      setArticleData({
        ...articleData,
        [props.tiny.data.name]: props.tiny.data.value
      });
    }, [props.tiny.data]);

    const onChange = (e: any) => {
      setArticleData({
        ...articleData,
        [e.target.name]: e.target.value
      });
    };

    const onImageChange = (imageList: ImageListType, addUpdateIndex: number[] | undefined) => {
      setImages(imageList as never[]);
    };

    const onDeleteCurrentImage = () => {
      setShowUpload(true);
    };

    const onKeepCurrentImage = () => {
      setShowUpload(false);
    };

    const handleSubmit = (e: any) => {
      e.preventDefault();
      const category_id = catData?.category_id;
      if (category_id > 0) {
        const file = GetUploadImage();

        submitNews({
          variables: {
            input: {
              id: articleData.id,
              image: !showUpload ? articleData.image : '',
              title: articleData.title,
              slug: articleData.slug,
              urltag: !IsReeltimeTag(props.urltag) ? props.urltag : '',
              ingress: articleData.ingress,
              category: category_id,
              body: articleData.body,
              publish: publish,
              externalUrl: articleData?.externalUrl
            },
            file
          }
        });
      }
    };

    const GetUploadImage = (): ImageType | null => {
      if (images && images.length > 0 && images[0]) {
        var img = images[0] as ImageType;
        if (img && img?.file) {
          return img.file;
        }
      }

      return null;
    };

    const OnToggle = (e: any) => {
      SetPublish(!publish);
    };

    if (props.tiny.tinyLoaded) {
      props.tiny.triggerTiny('#ingress', 200);
      props.tiny.triggerTiny('#body');
    }

    if (!context.adminState.loggedIn.status) {
      return <div></div>;
    }

    return (
      <Admincontent>
        <h1>Rediger</h1>
        <Editor>
          <form>
            {catData?.edit_image ? (
              <>
                <h2>Bilde</h2>
                {!showUpload ? (
                  <div>
                    <img src={isExternalURL(articleData.image).link} alt="" />
                    <ButtonGroup position="right">
                      <Button onClick={onDeleteCurrentImage} type="primary" colorTheme="gray">
                        Slett/Bytt bilde
                      </Button>
                    </ButtonGroup>
                  </div>
                ) : (
                  <ImageUploading multiple value={images} onChange={onImageChange} maxNumber={maxImages}>
                    {({ imageList, onImageUpload, onImageRemoveAll, onImageUpdate, onImageRemove, isDragging, dragProps }) => (
                      // UI here
                      <ImagesUploadingStyle>
                        <ButtonWrap>
                          {!(images && images.length >= maxImages) ? (
                            <Button
                              style={isDragging ? { color: '#4B4B4B' } : undefined}
                              type="primary"
                              colorTheme="gold"
                              onClick={onImageUpload}
                              {...dragProps}
                            >
                              Velg bilde
                            </Button>
                          ) : null}
                          {images && images.length > 1 ? (
                            <Button id="btn_remove" type="primary" onClick={onImageRemoveAll} colorTheme="gray">
                              Fjern alle bildene
                            </Button>
                          ) : null}
                          {articleData && articleData?.id && articleData?.id > 0 && articleData?.image ? (
                            <Button id="btn_img_cancel" type="primary" colorTheme="gray" onClick={onKeepCurrentImage}>
                              Behold forrige bilde
                            </Button>
                          ) : null}
                        </ButtonWrap>
                        {imageList.map((image, index) => (
                          <ImageDiv key={index}>
                            <img src={image.dataURL} alt="" width="250px" />
                            <ButtonGroup position="right">
                              <Button onClick={() => onImageRemove(index)} type="primary" colorTheme="gray">
                                Slett
                              </Button>
                            </ButtonGroup>
                          </ImageDiv>
                        ))}
                      </ImagesUploadingStyle>
                    )}
                  </ImageUploading>
                )}
              </>
            ) : null}

            <InputElement>
              <h2>Tittel</h2>
              <Input name="title" value={articleData.title} onChange={onChange} />
              <div style={{ marginBottom: '18px' }}></div>
            </InputElement>
            <InputElement>
              <h2>URL</h2>
              <Input
                name="externalUrl"
                type="url"
                pattern="http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w\- .\/?%&=]*)?"
                value={articleData?.externalUrl ? articleData?.externalUrl : ''}
                onChange={onChange}
              />
              <div style={{ marginBottom: '18px' }}></div>
            </InputElement>

            {catData?.edit_ingress ? (
              <InputElement>
                <div style={{ marginBottom: '30px', marginTop: '-56px' }}></div>
                <h2>Ingress</h2>
                <textarea id="ingress" name="ingress" defaultValue={articleData.ingress}></textarea>
                <div style={{ marginBottom: '18px' }}></div>
              </InputElement>
            ) : null}

            <InputElement>
              <div style={{ marginBottom: '18px', marginTop: '-24px' }}>
                <h2>Beskrivelse</h2>
              </div>
              <textarea id="body" name="body" defaultValue={articleData.body}></textarea>
            </InputElement>

            <EditButtonWrapper>
              <EditButtonChild style={{ justifyContent: 'start' }}>
                <ToggleCustomStyle
                  style={
                    {
                      /*marginTop: '10px'*/
                    }
                  }
                >
                  <label htmlFor="toggle-1">
                    <ToggleText>Publiser?</ToggleText>
                    <Toggle name="toggle-1" checked={publish} onToggle={OnToggle} />
                  </label>
                </ToggleCustomStyle>
              </EditButtonChild>
              <EditButtonChild style={{ justifyContent: 'end' }}>
                <Button
                  type="primary"
                  colorTheme="gold"
                  onClick={() => {
                    if (catData?.name && props?.urltag) {
                      history.push('/admin/' + props?.urltag + '/artikler/' + catData?.name);
                    } else {
                      history.goBack();
                    }
                  }}
                >
                  Tilbake
                </Button>
                <Button style={{ marginLeft: '20px' }} onClick={handleSubmit} type="primary" colorTheme="gold">
                  Lagre
                </Button>
              </EditButtonChild>
            </EditButtonWrapper>
          </form>
        </Editor>
      </Admincontent>
    );
  },
  (prevState, nextState) =>
    prevState.articleData.id === nextState.articleData.id &&
    prevState?.category?.id === nextState?.category?.id &&
    prevState.tiny.tinyLoaded === nextState.tiny.tinyLoaded &&
    prevState.tiny.data === nextState.tiny.data
);

const newArticle: Article = {
  id: null,
  image: '',
  imageCategory: '',
  slug: '',
  title: '',
  ingress: '',
  body: '',
  category: null
};

export const ArticleEditor = (props: {
  match: {
    params: { slug?: string; kontor: string; category?: string };
  };
}) => {
  const tiny = useTiny();
  const context = useContext(AdminContext);
  const [cat_key, SetCatKey] = useState<any>(props?.match?.params?.category);

  const [getCategory, { data: cdata, error: cerror, loading: cloading }] = useLazyQuery(NEWS_CATEGORY, {
    fetchPolicy: 'network-only',
    client: client
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (cat_key) {
      if (cat_key > 0) {
        getCategory({ variables: { input: { id: cat_key } } });
      } else {
        getCategory({ variables: { input: { key: cat_key } } });
      }
    }
  }, [cat_key]);

  if (props?.match?.params?.slug) {
    const { data, error, loading } = useQuery(SINGLE_NEWS_QUERY, {
      skip: !props?.match?.params?.slug,
      fetchPolicy: 'network-only',
      variables: {
        input: {
          type: NewsType.Nybyggportal,
          urltag: !IsReeltimeTag(props?.match?.params?.kontor) ? props?.match?.params?.kontor : '',
          slug: props?.match?.params?.slug
        }
      }
    });

    if (loading) {
      return <div>loading</div>;
    }

    if (error) {
      throw new Error('Det skjedde en feil');
    }

    if (data) {
      // Henter artikkel fra article tabellen i databasen
      const artikkel = data.getSingleNews;

      if (artikkel?.category && cat_key != artikkel?.category) {
        SetCatKey(artikkel?.category);
      }

      if (cdata?.getNewsCategory) {
        return <Form articleData={artikkel} urltag={props.match.params.kontor} tiny={tiny} category={cdata?.getNewsCategory} />;
      }
    }
  }

  if (!context.adminState.loggedIn.status) {
    return <div>Du er ikke logget inn</div>;
  }

  if (cdata?.getNewsCategory) {
    return <Form articleData={newArticle} urltag={props.match.params.kontor} tiny={tiny} category={cdata?.getNewsCategory} />;
  }

  return <div>loading</div>;
};

const Editor = styled.div`
  overflow: auto;
  margin: 0 auto 30px auto;
  width: 800px;
  img {
    width: 100%;
  }
`;

const EditButtonWrapper = styled.div`
  margin-top: 12px;
  position: relative;

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  text-align: center;
  grid-row-gap: 3em;

  @media all and (max-width: 1150px) {
    grid-template-columns: 1fr 1fr;
  }
  @media all and (max-width: 750px) {
    grid-template-columns: 1fr;
  }
`;

const EditButtonChild = styled.div`
  display: flex;
`;

const ImagesUploadingStyle = styled.div`
  width: 100%;
`;

export const InputElement = styled.div`
  padding: 2em 0 0;
  color: ${({ theme }) => theme.colors.white};
  h2 {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const ImageUpload = styled.div`
  position: relative;
  min-height: 200px;
  &:before {
    content: '';
    position: absolute;
    background-color: rgba(255, 255, 255, 0.3);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: 100px;
    background-repeat: no-repeat;
    background-image: url(https://www.pinclipart.com/picdir/big/335-3352982_png-file-file-upload-icon-svg-clipart.png);
    background-position: center;
  }
`;

const FileArea = styled.div`
  position: relative;
  height: 50px;
  display: table-cell;
  vertical-align: middle;
  padding: 10px;
  width: 100vw;
  color: ${({ theme }) => theme.colors.primary};
`;

const ButtonWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-bottom: 20px;

  button {
    float: right;

    :not(:first-child) {
      margin-left: 15px;
    }
  }
`;

const ImageDiv = styled.div`
  margin-bottom: 15px;
  margin-top: 15px;
`;

const ToggleCustomStyle = styled.div`
  padding-top: 8px;

  input[type='checkbox'] + label {
    height: 0px;
  }
  input[type='checkbox'] + label:after {
    background-color: #ff7220;
  }
  input[type='checkbox']:checked + label:after {
    background-color: #38c738;
  }
  .react-toggle {
  }
`;

const ToggleText = styled.div`
  padding-right: 3px;
  display: inline-block;
`;

export default ArticleEditor;
